import React from 'react';

import { colors } from '@styleseat/brand';
import { useMount } from '../../../../hooks';
import NotificationBanner from '../NotificationBanner';
import analytics from '../../../../modules/analytics';
import { NotificationsAlertTriangleIcon } from '../../../ui/Icons';

export type NotificationProps = {
  type: 'ncd_non_payment_appointment_notification';
  object_type: 'Appointment';
  appointment_id: string | number;
  provider_id: string | number;
  creation_time: string;
};

type ComponentProps = {
  onClick: () => void;
  notification: NotificationProps;
};

const Component: React.FC<ComponentProps> = ({ onClick, notification }) => {
  useMount(() => {
    analytics.track('No Pay Ncd Appointment Notification Viewed', {
      provider_id: notification.provider_id,
      appointment_id: notification.appointment_id,
    });
  });

  return (
    <NotificationBanner
      icon={NotificationsAlertTriangleIcon}
      iconColor={colors.sunshine}
      notification={notification}
      iconSize={40}
      buttonProps={{
        text: 'See Updated Score',
        size: 'small',
        appearance: 'outline',
        clickTracking: {
          name: 'No Pay Ncd Appointment Notification See Updated Score Clicked',
          params: {
            provider_id: notification.provider_id,
            appointment_id: notification.appointment_id,
          },
        },
        onClick,
      }}
      highlightedText="Your Top Pro status is at risk."
      text="We require new clients we send you to pay on StyleSeat."
    />
  );
};

export default Component;
